import React, { Component } from 'react';
import * as _ from 'lodash';
import { injectIntl, FormattedMessage, FormattedHTMLMessage } from 'react-intl';
import { observer } from 'mobx-react';
import { Api } from '../Api.js';
import navigationStructure from '../NavigationStructure.js';
import TableOfContents from '../components/TableOfContents.js';

import "../css/Conclusion.css";

class FeedbackForm extends Component {
  constructor(props) {
    super(props);
    this.state = {
      value: ''
    };
  }

  onSubmit(event) {
    event.preventDefault();
    const formData = new FormData();
    formData.append('feedback', "PROTECT: "+this.state.value);

    Api.post('/report/feedback', formData).then((response) => {
      alert(this.props.thankyouText);
    }).catch(function(error) {
      console(error);
      alert(this.props.errorText);
    });
  }

  handleChange(event) {
    this.setState({ value: event.target.value });
  }

  render() {
    return (
        <form className="feedback" onSubmit={this.onSubmit.bind(this)}>
          <textarea value={this.state.value} onChange={this.handleChange.bind(this)} />

          <p>
            <input type="submit" value={this.props.sendButtonText} className='button lowpriority' />
          </p>
        </form>
    );
  }
}

class ConclusionPage extends Component {
  onClick(path) {
    //this.props.history.push(path);
    window.scrollTo(0, 0);
  }

  render() {
    const filterer = value => {
      const group_name = this.props.intl.messages[`chemicals.${value.group}.data`];
      if(this.props.appState.groups[group_name] !== undefined && this.props.appState.groups[group_name].length > 0) {
        return _.filter(this.props.appState.groups[group_name], { mine: true }).length > 0
      }
      else return false
    };

    const summary_items = Object.values(navigationStructure)
      .filter(value => value.summary)
      .filter(filterer)

    const water_summary_items = Object.values(navigationStructure)
      .filter(value => value.water_summary)
      .filter(filterer)

    /*
      <FeedbackForm
            thankyouText={this.props.intl.messages['app.conclusion.thankyou']}
            errorText={this.props.intl.messages['app.conclusion.error']}
            sendButtonText={this.props.intl.messages['app.login.submit']} />
    */

    return (
      <div className='conclusion page'>
        <h1>
          <FormattedMessage id='page.conclusion.title' />
        </h1>

        <FormattedHTMLMessage id='page.conclusion.content' />

        <div className='toc printhide'>
          <hr />

          <p>
            <FormattedHTMLMessage id='page.conclusion.see_again' />
          </p>

          <TableOfContents appState={this.props.appState} history={this.props.history} items={summary_items} />
        </div>

      </div>
    )
  }
}

export default observer(injectIntl(ConclusionPage));



// WEBPACK FOOTER //
// ./src/pages/ConclusionPage.js